module.exports = __webpack_public_path__ + "img/pot-video.cd42aaf7.webp";